import { useRepresentativesModal } from 'pages/Representatives/context/RepresentativesModalProvider';
import { useCallback, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { REPRESENTATIVES_QUERY_STRING } from 'shared/constants/REPRESENTATIVES_QUERY_STRING';
import { setUser } from 'shared/redux/slicers/user.slicer';
import { useAppSelector } from 'shared/redux/store';
import { profileService } from 'shared/services/profileService';
import { FileType } from 'shared/enums/FileType';
import IMedia from 'shared/interfaces/IMedia';

const { setProfilePrimaryImage } = profileService();

export const useEditProfileMediaBin = (callback: VoidFunction) => {
  const dispatch = useDispatch();
  const { user: userState } = useAppSelector((state) => state);
  const { id: profileId } = useParams() as { id: string };
  const { handleOpen, handleSetMessage } = useRepresentativesModal();
  const { mutate: primaryImageMutate, isLoading } = setProfilePrimaryImage();
  const queryClient = useQueryClient();
  const [openMediaBin, setOpenMediaBin] = useState<boolean>(false);

  const handleOpenMediaBin = useCallback(() => {
    setOpenMediaBin((prev) => !prev);
  }, []);

  const addMedia = useCallback((media: IMedia[]) => {
    const formData = new FormData();
    formData.set('medium_id', media[0].id);
    primaryImageMutate(
      {
        profileId,
        formData,
      },
      {
        onSuccess: (data) => {
          dispatch(
            setUser({
              user: {
                ...userState.user,
                attributes: {
                  ...userState.user?.attributes,
                  picture: data.data.attributes.modified_attachment,
                },
              },
            }),
          );
          queryClient.invalidateQueries([REPRESENTATIVES_QUERY_STRING.representatives_single_profile, profileId]);
          queryClient.invalidateQueries([REPRESENTATIVES_QUERY_STRING.representatives_multiple_profile], {
            refetchInactive: true,
          });
          queryClient.invalidateQueries([
            REPRESENTATIVES_QUERY_STRING.representatives_single_profile_attached_media,
            profileId,
            FileType.IMAGE,
          ]);
          callback();
        },
        onError: (error) => {
          const message =
            error?.response?.data?.errors?.profile_id[0] === 'not permitted to attach file'
              ? error?.response?.data?.errors?.profile_id[0]
              : 'Setting up your primary image is not available for now';
          handleSetMessage('Try again later', message, 'Close');
          handleOpen();
          callback();
        },
      },
    );
  }, []);

  return { openMediaBin, isLoading, addMedia, handleOpenMediaBin };
};
